module.exports = __webpack_public_path__ + "img/feedbackuse1.3a5a8b82.png";